import { hm5LimitedReleasesListConstants } from "../_redux-constants";
import { hm5LimitedReleasesListService } from "../../_services";

function getHM5LimitedReleasesList(queryParams) {
  function getHM5LimitedReleasesListLoad() {
    return {
      type: hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getHM5LimitedReleasesListSuccess(data) {
    return {
      type: hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getHM5LimitedReleasesListFailure(error) {
    return {
      type: hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHM5LimitedReleasesListLoad());
    return hm5LimitedReleasesListService
      .getHM5LimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getHM5LimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getHM5LimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const hm5LimitedReleasesListActions = {
  getHM5LimitedReleasesList,
};
